var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" @cobrox ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }